/*
 * @Description: 
 * @Author: dezhi
 * @Date: 2019-08-26 09:11:29
 * @LastEditTime: 2021-05-11 10:43:57
 * @LastEditors: zhaoshuai
 */
// const api2 = 'http://192.168.4.40:26040/v1.0.0/';
// const api2 = 'http://192.168.4.110:26040/v1.0.0/';
// axios.defaults.headers.common['X_AUTH_TOKEN'] = localStorage.getItem("token");
import axios from "../../http";
const state = {
    studentInfo: {}
}

// getters
const getters = {

}

// actions
const actions = {
    /**
     * @description: 新增考生信息
     * @param {commit} 
     * @return: 
     */
    async getStudentInfo({ commit }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/enrollInfo/getEnrollInfoDetails?orderCode=${payload.orderCode}&userCode=${payload.userCode}&examCode=${payload.examCode}`)
        localStorage.setItem('studentInfo', JSON.stringify(res.data.data))
        commit('saveStudentInfo', res.data.data)
        return res;
    },
    //获取图片
    async getPicUrl({ commit }, payload) {
        const res = await axios.post('/v1.0.0/exammgr/upload/uploadFile', payload).then((response) => {
            return Promise.resolve(response)
        }).catch((e) => {
            console.log(e)
            return Promise.reject(new Error('fail'))
        })
        // if (res.data.status == 2000) {
        //     let data = res.data.data;
        //     // 设置用户id和token到cookie
        //     commit('login', {
        //         userInfo: data.userInfo,
        //         token: data.token
        //     })

        // }
        console.log(commit)
        return res
    },
    /**
     * @description: 新增考生信息
     * @param {commit} 
     * @return: 
     */
    async addStudentAction({ commit }, payload) {
        const res = await axios.post(`/v1.0.0/exammgr/enrollInfo/insertByInsertParam`, payload)
        console.log(res, commit)
        return res;
    },
    /**
     * @description: 修改考生信息
     * @param {commit} 
     * @return: 
     */
    async updateStudentAction({ dispatch }, payload) {
        const res = await axios.post(`/v1.0.0/exammgr/enrollInfo/updateByUpdateParam`, payload)
        let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
        dispatch('getStudentInfo', {
            orderCode: userInfo.orderCode,
            userCode: userInfo.userCode,
            examCode: userInfo.examCode,
        })
        return res;
    },
    /**
     * @description: 上传承诺书
     * @param {commit} 
     * @return: 
     */
    async updateBookAction({ dispatch }, payload) {
        const res = await axios.post(`/v1.0.0/exammgr/enrollInfo/updateDeclareUrlById/${JSON.parse(localStorage.getItem("studentInfo")).enrollInfoId}`, payload)
        let userInfo = JSON.parse(localStorage.getItem("apply_userInfo"));
        dispatch('getStudentInfo', {
            orderCode: userInfo.orderCode,
            userCode: userInfo.userCode,
            examCode: userInfo.examCode,
        })
        return res;
    },
    /**
     * @description: 获取考点地址
     * @param {commit} 
     * @return: 
     */
    async getExamPlace({ dispatch }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/examArea/queryList`, {
            params: {
                examCode: payload.examCode,
                deleteFlag: 0,
                status: 1
            }
        })
        console.log(dispatch)
        return res;
    },
    /**
     * @description: 获取手机验证码
     * @param {commit} 
     * @return: 
     */
    async getPhoneCode({ dispatch }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/enrollInfo/check`, {
            params: {
                phone: payload
            }
        })
        console.log(dispatch)
        return res;
    },
    /**
     * @description: 验证手机号
     * @param {commit} 
     * @return: 
     */
    async validPhoneCode({ dispatch }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/enrollInfo/verifyPhoneAndCode`, {
            params: {
                phone: payload.phone,
                code: payload.code
            }
        })
        console.log(dispatch)
        return res;
    },
    /**
     * @description: 获取考生信息
     * @param {commit} 
     * @return: 
     */
    async getExamInfo({ dispatch }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/admissionTicket/enrollinfo`, {
            params: {
                enrollInfoId: payload
            }
        })
        console.log(dispatch)
        return res;
    },
     /**
     * @description: 修改补考学生的考区
     * @param {commit} 
     * @return: 
     */
      async updateAreaAction({ dispatch }, payload) {
        const res = await axios.post(`/v1.0.0/exammgr/enrollInfo/saveEnrollInfo`, 
           
               payload
          
        )
        console.log(dispatch)
        console.log(res)
        return res;
    },
    /**
     * @description: 判断订单状态
     * @param {commit} 
     * @return: 
     */
     async judgeOrderStatus({ dispatch }, payload) {
        const res = await axios.post(`/v1.0.0/user/examuser/confirmOrder?userCode=${payload.userCode}&examCode=${payload.examCode}`, 
           
       
          
        )
        console.log(dispatch)
        console.log(res)
        return res;
    },
      /**
     * @description: 获取补考学生消息
     * @param {commit} 
     * @return: 
     */
       async secondStuMsg({ dispatch }, payload) {
        const res = await axios.post(`/v1.0.0/exammgr/enrollInfo/querySaveEnrollInfo?userCode=${payload.userCode}&examCode=${payload.examCode}`, 
           
       
          
        )
        console.log(dispatch)
        console.log(res)
        return res;
    },
    /**
     * @description: 获取考生信息
     * @param {commit} 
     * @return: 
     */
    async getDownloadTime({ dispatch }, payload) {
        const res = await axios.get(`/v1.0.0/exammgr/admissionTicket/updateScoreInfo`, {
            params: {
                enrollInfoId: payload
            }
        })
        console.log(dispatch)
        return res;
    },
}

// mutations

const mutations = {
    saveStudentInfo(state, payload) {
        // state.classInfo = state.infoList[payload - 1];
        state.studentInfo = payload;
    }
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}